import { createIcon } from '@chakra-ui/react';
import React from 'react';

const displayName = `Logo`;

const viewBox = `0 0 121.55 50`;

const path = (
  <>
    <path
      d="M64.27,6.36a1.85,1.85,0,0,1,3.16-1.31,1.84,1.84,0,0,1,0,2.62,1.86,1.86,0,0,1-3.16-1.31Zm3.26,19.78A8.63,8.63,0,0,1,67.32,28a10.19,10.19,0,0,1-.6,1.87,9.3,9.3,0,0,1-1,1.71,5.94,5.94,0,0,1-1.31,1.34,1.36,1.36,0,0,1-.87.31,1.33,1.33,0,0,1-1-.45,1.51,1.51,0,0,1-.42-1,1,1,0,0,1,.27-.77c.18-.16.37-.35.58-.55a5.56,5.56,0,0,0,1.27-2,6.27,6.27,0,0,0,.44-2.3V12.24a1.27,1.27,0,0,1,.44-1.06,1.51,1.51,0,0,1,1.93,0,1.26,1.26,0,0,1,.44,1.06Z"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M77.92,19.57l-3,.67a4.05,4.05,0,0,0-2.08,1A2.1,2.1,0,0,0,73,24.37a3.08,3.08,0,0,0,2.1.65,2.91,2.91,0,0,0,2.08-.74,2.45,2.45,0,0,0,.79-1.84Zm2.81,2.86a5.26,5.26,0,0,1-.46,2.22A5.51,5.51,0,0,1,79,26.35a5.67,5.67,0,0,1-1.8,1.1,6.27,6.27,0,0,1-2.14.38A7,7,0,0,1,73,27.51a5.73,5.73,0,0,1-1.83-1A4.59,4.59,0,0,1,69.88,25a5,5,0,0,1-.48-2.22,4.54,4.54,0,0,1,.45-2A5.23,5.23,0,0,1,71,19.19a6.1,6.1,0,0,1,1.69-1,11.27,11.27,0,0,1,2-.62l3.23-.7V16a2.69,2.69,0,0,0-.65-1.88,2.75,2.75,0,0,0-2.14-.7,2.62,2.62,0,0,0-1.26.26,5,5,0,0,0-.83.59,7.23,7.23,0,0,1-.69.59,1.28,1.28,0,0,1-.84.27,1.45,1.45,0,0,1-1-.39,1.37,1.37,0,0,1-.42-1,1.56,1.56,0,0,1,.14-.63,2.14,2.14,0,0,1,.37-.52,5.24,5.24,0,0,1,2-1.47A6.62,6.62,0,0,1,77.47,11a5.25,5.25,0,0,1,1.77,1.13,4.82,4.82,0,0,1,1.11,1.7A5.89,5.89,0,0,1,80.73,16Z"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M83,12.23a1.24,1.24,0,0,1,.44-1.05,1.48,1.48,0,0,1,1-.35,1.52,1.52,0,0,1,1,.35,1.26,1.26,0,0,1,.43,1.05V26.14a1.3,1.3,0,0,1-.43,1.06,1.58,1.58,0,0,1-1,.35,1.54,1.54,0,0,1-1-.35A1.27,1.27,0,0,1,83,26.14Zm-.45-5.87A1.88,1.88,0,0,1,84.44,4.5a1.82,1.82,0,0,1,1.3.55,1.84,1.84,0,0,1,0,2.62,1.85,1.85,0,0,1-2.61,0A1.86,1.86,0,0,1,82.58,6.36Z"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M106.67,27.19a1.52,1.52,0,0,1-1.94,0,1.26,1.26,0,0,1-.43-1.05V16a2.56,2.56,0,0,0-.22-1,2.6,2.6,0,0,0-1.43-1.43,2.55,2.55,0,0,0-1-.21,2.31,2.31,0,0,0-1,.21,2.59,2.59,0,0,0-.85.57,2.75,2.75,0,0,0-.57.86A2.55,2.55,0,0,0,99,16V26.14a1.34,1.34,0,0,1-.44,1.1,1.46,1.46,0,0,1-1.94,0,1.3,1.3,0,0,1-.43-1.1V16a2.55,2.55,0,0,0-.21-1,2.78,2.78,0,0,0-.58-.86,2.75,2.75,0,0,0-.86-.57,2.55,2.55,0,0,0-1-.21,2.31,2.31,0,0,0-1,.21,2.7,2.7,0,0,0-.85.57A2.75,2.75,0,0,0,91,15a2.55,2.55,0,0,0-.21,1V26.14a1.27,1.27,0,0,1-.44,1.06,1.54,1.54,0,0,1-1,.35,1.58,1.58,0,0,1-1-.35A1.3,1.3,0,0,1,88,26.14V16a5.2,5.2,0,0,1,.43-2.13,5.55,5.55,0,0,1,1.17-1.74A5.68,5.68,0,0,1,91.33,11a5.54,5.54,0,0,1,4.42.06,5.4,5.4,0,0,1,1.8,1.34A5.61,5.61,0,0,1,99.35,11a5.26,5.26,0,0,1,2.28-.49,5.37,5.37,0,0,1,2.13.43,5.71,5.71,0,0,1,1.75,1.17,5.52,5.52,0,0,1,1.16,1.74,5.43,5.43,0,0,1,.44,2.14V26.14a1.34,1.34,0,0,1-.44,1.06"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M121.52,12.17a1.24,1.24,0,0,1,0,.27,2.76,2.76,0,0,1-.08.27l-7.28,19.53a1.28,1.28,0,0,1-1.27.93,1.59,1.59,0,0,1-1-.37,1.28,1.28,0,0,1-.42-1.25,1.43,1.43,0,0,1,.09-.27l2-5.2-4.86-13.23a1.91,1.91,0,0,1-.1-.34,1.27,1.27,0,0,1,0-.34,1.18,1.18,0,0,1,.45-1,1.55,1.55,0,0,1,1-.37,1.47,1.47,0,0,1,.76.23,1.29,1.29,0,0,1,.53.7L115,22.29l3.82-10.54a1.28,1.28,0,0,1,.52-.71,1.44,1.44,0,0,1,.75-.21,1.54,1.54,0,0,1,1,.36,1.22,1.22,0,0,1,.45,1"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <rect
      x="0.03"
      y="8.28"
      width="29.42"
      height="29.42"
      style={{ fill: `none` }}
    />
    <path
      d="M14.68,37.69a14.71,14.71,0,1,1,0-29.41A2.71,2.71,0,0,1,17.39,11h0a2.71,2.71,0,0,1-2.71,2.71h0A9.29,9.29,0,1,0,24,23a2.71,2.71,0,1,1,5.42,0,14.71,14.71,0,0,1-14.7,14.7"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M39.84,29.42a2.71,2.71,0,0,1-2.71-2.72h0A2.71,2.71,0,0,1,39.84,24a9.29,9.29,0,1,0-9.28-9.29,2.71,2.71,0,0,1-2.71,2.72h0a2.72,2.72,0,0,1-2.72-2.71h0A14.71,14.71,0,1,1,39.84,29.42"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
  </>
);

export const LogoNoBelfiusText = createIcon({ displayName, viewBox, path });
